import React from 'react'
import { Link } from "react-router-dom";


const MulayamSinghYadav = () => {
    return (
        <>
            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2> Dr. Mulayam Singh Yadav </h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}> Ortho</li>
                    </ul>
                </div>
            </section>

            <section className="process-one" style={{ marginTop: "-90px" }}>
                <div className="auto-container">
                    <div className="row clearfix">
                        <marquee width="100%" direction="left" height="" ><br />
                            <b className='' style={{ fontSize: "18px", color: "green" }}>   उपलब्धता:-
                                महीने में 2 बार ग्वालियर
                                ✅  महीने में 1 बार भोपाल
                                ✅  महीने में 1 बार - जबलपुर
                                ✅  रोजाना - सतना</b>
                        </marquee>
                        {/* Process Block */}
                        <div className="process-block col-lg-4 col-md-12 col-sm-12">
                            <div className="process-block_inner">


                                <div className="process-block_image">
                                    <span className="process-block_icon flaticon-medical-history" style={{ color: '#0f903f' }} />
                                    <img src="assets/img/Dr. Mulayam Singh Yadav.webp" alt />
                                </div>
                            </div>
                        </div>
                        {/* Process Block */}
                        <div className="process-block col-lg-8 col-md-12 col-sm-12">
                            <div className="process-block_inner">
                                <div className="process-block_content">
                                    <div className="process-block_title">
                                        <span className="process-block_number"> 8 Years experience</span>
                                    </div>
                                    <br />
                                    <br />
                                    <br />
                                    <h3 className="process-block_heading">Dr. Mulayam Singh Yadav</h3>
                                    <p> ( Gold Medalist) MBBS, MS Orthopedic, D.Ortho </p>
                                    <h4>About him:</h4>
                                    <div className="process-block_text" style={{ marginTop: "0px" }}>
                                        नमस्कार,
                                        मेरा नाम डॉ. मुलायम सिंह यादव है और मैं हड़ी एवं जोड़ रोग विशेषज्ञ हूं। मैंने एमबीबीएस एन.एस.सी.बी. मेडिकल कॉलेज, जबलपुर से किया है और पोस्ट ग्रेजुएशन हड्डी एवं जोड़ रोग विशेषज्ञ जी.आर.एम.सी. ग्वालियर से पूर्ण किया है। जिसमें मुझे गोल्ड मेडल प्राप्त हुआ है। वर्तमान में मैं एक अनुभवी ट्रॉमा एवं जॉइंट रिप्लेसमेंट सर्जन हूं। पिछले 8 वर्षों के अनुभव में मैंने देखा है कि जब मरीजों को घुटनों के खराब होने (घुटनों का ऑस्टियोआर्थराइटिस), कंधे के जाम होने या दर्द (फोजन शोल्डर), एड़ी में दर्द (प्लांटर फैसाइटिस) या फिर कोहनी की समस्या होती है, तो कई बार उन्हें सीधे सर्जरी की सलाह दे दी जाती है। लेकिन मैं आपसे यही कहना चाहता हूं कि सर्जरी से पहले एक बार PRP या स्टेम सेल थेरेपी अवश्य आजमाएँ।
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            </section>

            <div className="sidebar-page-container left-sidebar" style={{ marginTop: "-230px" }}>
                <div className="auto-container">

                    <div className="row clearfix">
                        <div className="content-side col-lg-12 col-md-12 col-sm-12">
                            <div className="department-detail">
                                <div className="inner-box" >
                                    <h3 className='mt-lg-4'>Conditions we treat</h3>
                                    <div className="graph-outer">
                                        <div className="row clearfix">
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <b> ये थेरेपी किन रोगों में असरदार है:</b>
                                                    <li className='mt-lg-4'> घुटनों का ऑस्टियोआर्थराइटिस-स्टेज 1, स्टेज 2 और स्टेज 3</li>
                                                    <li> घुटने की अन्य समस्याओं जैसे कि लिगामेंट, भेनिसकस एवं टेंडन की समस्या </li>
                                                    <li> कंधे का जाम होना-फ्रोजन शोल्डर </li>
                                                    <li> एड़ी का दर्द-प्लांटर फैसाइटिस</li>
                                                    <li> कोहनी का दर्द जैसे टेनिस एलवो, गोल्फर एलवो इत्यादि</li>
                                                    <li> इन स्थितियों में PRP और स्टेम सेल थेरेपी बहुत ही कारगर और सुरक्षित पाई गई है।</li>

                                                </ul>
                                            </div>
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <b>PRP धेरेपी-लंबे समय के दर्द में बिना सर्जरी के उचित, सुरक्षित एवं नेचुरल इलाज</b>
                                                    <li className='mt-lg-4'> दर्द से राहत</li>
                                                    <li> सूजन में कमी</li>
                                                    <li> क्षतिग्रस्त ऊतकों की प्राकृतिक मरम्मत</li>
                                                    <li> सर्जरी के बिना इलाज</li>
                                                    <li> शरीर की प्राकृतिक उपचार प्रणाली (Regenerative Therapy) को सक्रिय करता है।</li>
                                                    <li> कोई साइड इफेक्ट नहीं</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <b>PRP थेरेपी कैसे की जाती है?</b>
                                        <p> हड्डी एवं जोड़ रोग में PRP थेरेपी 1 नोबल, उभरती हुई प्राकतिक चिकित्सा पद्धति है जिसमें मरीज के स्वयं के रक्त से PRP इंजेक्शन बना के दर्द वाली जगह पर लगाया जाता है और इसके साइड इफेक्ट भी ना के बराबर होते हैं।
                                            अब तक यह PRP थेरेपी विदेशों में एवं भारत में दिल्ली, मुंबई, अहमदाबाद, हैदराबाद, बैंगलोर जैसे बड़े शहरों में काफी उच्च दामो में होती थी लेकिन अब यह मध्यप्रदेश के शहरों में उचित दाम में उपलब्ध है</p>
                                    </div>
                                    <div className="graph-outer">
                                        <div className="row clearfix">
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <b> एड़ी के नीचे दर्द, प्लांटर फैसाइटिस में PRP थैरेपी</b>

                                                    <li className='mt-lg-4'> Plantar Fasciitis एड़ी के नीचे तेज़ दर्द का एक आम कारण है। यह समस्या तब होती है जब तलवे में पैर की एड़ी से लेकर उंगलियों तक जाने वाले रेशेदार ऊतक (Plantar Fascial) में खिंचाव या सूजन आ जाती है। यह रोग खासतौर पर उन लोगों में देखा जाता है</li>
                                                    <li> जो ज्यादा देर खड़े रहते हैं या चलते हैं। </li>
                                                    <li> जिन्हें फ्लैट फीट या अधिक ऊँची एड़ी है </li>
                                                    <li> खेल-कूद करने वाले या कामकाजी लोग जिनकी एड़ी पर बार-बार दबाव पड़ता है। </li>
                                                    <li> जिन्हें मोटापा है। </li>


                                                </ul>
                                            </div>
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <b>PRP थेरेपी क्या है और में कैसे काम करती है?</b>
                                                    <p>PRP (Platelet-Rich Plasma) थेरेपी में रोगी के अपने खून से प्लेटलेट्स को अलग करके एक केंद्रित प्लाज्मा तैयार किया जाता है, जिसमें प्राकृक्तिक रूप से भरपूर मात्रा में ग्रोथ फैक्टर्स (Growth Factors) होते हैं। इन ग्रोथ फैक्टर्स का कार्य शरीर की
                                                        मरम्मत प्रणाली को तेज़ करना होता है।</p>
                                                        <b>Plantar Fasciitis में PRP थेरेपी कैसे काम करती है?</b>
                                                    <li className='mt-lg-4'> PRP को एड़ी के उस हिस्से में इंजेक्ट किया जाता है, जहाँ Plantar Fascia में सूजन या चोट होती है।</li>
                                                    <li> यह इंजेक्शन सूजन को कम करता है और ऊतक पुनर्जनन (Tissue Regeneration) की प्रक्रिया को तेज़ करता है</li>
                                                    <li> शरीर की अपनी हीलिंग पावर सक्रिय होती है, जिससे दर्द कम होता है और व्यक्ति पहले की तरह चलने-फिरने लगता है।</li>
                                                    
                                                </ul>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className="graph-outer">
                                        <div className="row clearfix">
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <b> PRP के लाभ : </b>

                                                    <li className='mt-lg-4'> बिना सर्जरी का उपचार </li>
                                                    <li> स्टेरॉइड कतक राहत </li>
                                                    <li> नेचुरल उपचार-शरीर की अपनी कोशिकाएं काम करती हैं </li>
                                                    <li> कोई रिएक्शन या रिजेक्शन नहीं क्योंकि ये खून आपके शरीर का ही होता है </li>
                                                    <li> ऑफिस वर्क या डेली एक्टिविटी में जल्द वापसी तुलना में अधिक सुरक्षित </li>
                                                    <li>  लंबे समय </li>


                                                </ul>
                                            </div>
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                    <b> ध्यान रखने योग्य बातें</b>
                                                    <li className='mt-lg-4'> PRP थेरेपी एक बार या कभी-कभी दो से तीन बार दी जा सकती है, रोग की गंभीरता पर निर्भर करता है</li>
                                                    <li> इलाज के बाद कुछ दिन आराम और स्पेशल शू सपोर्ट जरूरी होता है</li>
                                                    <li> फिजियोथेरेपी और स्ट्रेचिंग एक्सरसाइज के साथ और बेहतर परिणाम मिलते हैं</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <b> कब सोचे PRP थेरेपी के बारे में? </b>
                                        <p> जब दवा, फिजियोथेरेपी और आराम से भी आराम न मिले जब स्टेरॉइड इंजेक्शन का असर अल्पकालिक हो जब सर्जरी से बचना चाहते हों जब रोज़मर्रा के काम दर्द की वजह से बाधित हो रहे हों। </p>
                                        <b> निष्कर्ष :</b>
                                        <p>PRP थैरेपी प्लांटर फैसाइटिस के इलाज में एक सुरक्षित, प्राकृतिक और प्रभावी उपाय है, जो ऊतक को दोबारा स्वस्थ बनाकर दर्द से स्थायी राहत दिलाने में मदद करता है।</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>





        </>
    )
}

export default MulayamSinghYadav